import React from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { reduxForm } from 'redux-form/immutable'

import styles from './editProviderInfo.module.scss'
import ProviderInfoForm from '../../../common/components/forms/providerInfo/ProviderInfoForm'
import providerInfoValidate from '../../../common/components/forms/providerInfo/providerInfoValidate'
import { PROVIDERS_DETAILS_INFO } from '../../../common/constants/routingConstants'

type EditProviderInfoProps = {
  handleSubmit?: (...args: any[]) => any
  submitting?: boolean
  navigate: NavigateFunction
}

class EditProviderInfo extends React.Component<EditProviderInfoProps> {
  _submitForm = (_: any) => {
    // TODO flesh out like provider register when we get there
    this.props.navigate(PROVIDERS_DETAILS_INFO.route, { replace: true })
  }

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <div className={styles['content-container']}>
        <h2 className={styles.title}>Edit Provider Info</h2>

        <ProviderInfoForm
          handleSubmit={handleSubmit}
          submitFunction={this._submitForm}
          submitting={submitting}
          primaryButtonText='Save'
        />
      </div>
    )
  }
}

const ConnectedEditProviderInfo = reduxForm({
  form: 'editProviderInfoForm',
  validate: providerInfoValidate,
  touchOnBlur: false,
  // @ts-expect-error TS(2345): Argument of type 'typeof EditProviderInfo' is not ... Remove this comment to see the full error message
})(EditProviderInfo) as unknown as React.ComponentType<{
  navigate: NavigateFunction
  initialValues?: any
}>

export default function EditProviderInfoWithRouter(props: { initialValues?: any }) {
  const navigate = useNavigate()
  return <ConnectedEditProviderInfo {...props} navigate={navigate} />
}
